import React from 'react';
import MatClntCoreTransactionList from './MatClntCoreTransactionList';

export default function MatClntTransferList() {
  return (
    <MatClntCoreTransactionList
      title="Client Material - Transfer Transactions"
      opTypes={["transfer"]}
    />
  );
}
